import firebase from '@firebase/app'
import '@firebase/auth'
// The configuration below is not sensitive data. You can serenely add your config here
// const config = {
//   apiKey: 'AIzaSyAN16eeO090BrkuC0eoLY4B1KyUMRVga8w',
//   authDomain: 'vuesaga-b8d1b.firebaseapp.com',
//   databaseURL: 'https://vuesaga-b8d1b.firebaseio.com',
//   projectId: 'vuesaga-b8d1b',
//   storageBucket: 'vuesaga-b8d1b.appspot.com',
//   messagingSenderId: '881671157243',
//   appId: '1:881671157243:web:cf52f28243ea091d59c75e',
//   measurementId: 'G-HD5SS508JX'
// }

const config = {
  apiKey: 'AIzaSyB7WNIU2f0CcrZiDVyIpB1Xt1Pae4Y--Gg',
  authDomain: 'saga-dashboard.firebaseapp.com',
  databaseURL: 'https://saga-dashboard.firebaseio.com',
  projectId: 'saga-dashboard',
  storageBucket: 'saga-dashboard.appspot.com',
  messagingSenderId: '396400584415',
  appId: '1:396400584415:web:d695a36e597f3f75eb2b6a',
  measurementId: 'G-ENJY06N219'
}

firebase.initializeApp(config)
